import * as React from "react";
import { useCallback } from "react";
import Popover from "components/common/Popover";
import SearchFilterForm from "search-filter/components/search-filter-bar/SearchFilterForm";
import useUserSearchFilterMutation from "search-filter/hooks/useUserSearchFilterMutation";
import generateId from "logic/generateId";
import { REFERENCED_USER_SEARCH_FILTER_TYPE, INLINE_SEARCH_FILTER_TYPE } from "search-filter/constants";
import { CurrentUserStore } from "stores/users/CurrentUserStore";
const SearchFilterCreatePopover = ({ children = void 0, onSubmit, onCancel, show }) => {
  const { post } = useUserSearchFilterMutation();
  const handleFormSubmit = useCallback(
    (filterData, checked) => {
      if (checked) {
        return post({ data: filterData }).then(
          (data) => CurrentUserStore.reload().then(
            () => onSubmit({ ...data, frontendId: data.id, type: REFERENCED_USER_SEARCH_FILTER_TYPE })
          )
        );
      }
      const newId = generateId();
      return onSubmit({ ...filterData, id: newId, frontendId: newId, type: INLINE_SEARCH_FILTER_TYPE });
    },
    [onSubmit, post]
  );
  const onClose = useCallback(() => onCancel(), [onCancel]);
  return /* @__PURE__ */ React.createElement(
    Popover,
    {
      position: "bottom-start",
      width: 450,
      opened: show,
      withArrow: true,
      onClose,
      closeOnClickOutside: false,
      withinPortal: true
    },
    /* @__PURE__ */ React.createElement(Popover.Target, null, children),
    /* @__PURE__ */ React.createElement(Popover.Dropdown, { title: "Create Filter", id: "create-search-filter-dropdown" }, /* @__PURE__ */ React.createElement(
      SearchFilterForm,
      {
        onCancel,
        onSubmit: handleFormSubmit,
        checkboxLabel: 'Save to "My Filters"',
        helpText: 'This action will save this filter in your "My Filters" collection. These filters can be reused in other searches. Changes to this filter will affect all related searches.',
        helpTitle: 'Save to "My Filters"',
        submitButtonText: "Create filter",
        submitLoadingText: "Creating filter..."
      }
    ))
  );
};
export default SearchFilterCreatePopover;
